const MobileNavigation = (selectorValue) => {
    var navigation = document.querySelector(`[data-mobile-navigation]`);
    var navigationContainer = document.querySelector(`[data-mobile-navigation-container="${selectorValue}"]`);
    var navigationToggles = [...document.querySelectorAll(`[data-mobile-navigation-toggle="${selectorValue}"]`)];
    var isOpen = false;

    if (!navigation || !navigationContainer || !navigationToggles) return;

    navigation.addEventListener(
        'touchmove',
        function (e) {
            e.preventDefault();
        },
        false
    );

    navigationToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            isOpen ? _closeNavigation(navigationContainer) : _openNavigation(navigationContainer);
        });
    });

    function _closeNavigation(container) {
        isOpen = false;
        container.classList.add('-translate-x-full');
        setTimeout(() => {
            container.classList.add('hidden');
        }, 700);
    }

    function _openNavigation(container) {
        isOpen = true;
        container.classList.remove('hidden');
        setTimeout(() => {
            container.classList.remove('-translate-x-full');
        }, 40);
    }
};

export { MobileNavigation };
